export const selectedCloudConfigKey = 'selectedCloudConfiguration';

export const recentlyUpdatedProjectsKey = 'recentProjectsIds';
export const recentProjectIdsLimit = 3;

export const recentlyVisitedProjectIdsKey = 'recentlyVisitedProjectIds';
export const recentlyVisitedProjectIdsLimit = 5;

export const connectCloudQueryCtaDismissedKey = (userId: string | undefined, organizationId: string) =>
  `connect-cloudquery-cta-dismissed-${userId}-${organizationId}`;

export const needReviewEnvironmentProjectIdsFilterKey = 'needReviewEnvironmentProjectIdsFilter';
export const needReviewEnvironmentTemplateIdsFilterKey = 'needReviewEnvironmentTemplateIdsFilter';
